export default __webpack_public_path__ + "static/media/RVL-logo-black-text-white-bg.79b99922.png";